import { z } from 'zod';

export const DsiInspectionResult = z.enum(['detection-correct', 'detection-incorrect', 'faulty', 'unsure']);
export type DsiInspectionResult = z.infer<typeof DsiInspectionResult>;

export const DsiInspectionConfirmationResult = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('product-missing') }),
    z.object({ kind: z.literal('product-not-missing') }),
    z.object({ kind: z.literal('product-scanned-at-cashier') }),
    z.object({
        kind: z.literal('other'),
        reason: z.string().nullish(),
    }),
]);
export type DsiInspectionConfirmationResult = z.infer<typeof DsiInspectionConfirmationResult>;
